module.exports = __webpack_public_path__ + "img/badge_notifiche_welfarebit.25b1d371.jpg";